module.exports = "/packs/images/homepage/facilities/better_health_for_me~fafcf84b27b6cdac96e573f1434369bc.jpg";